// extracted by mini-css-extract-plugin
export var dark = "klaviyoForm-module--dark--ee1cf";
export var gridAlignment = "klaviyoForm-module--gridAlignment--d4c7e";
export var klaviyoForm = "klaviyoForm-module--klaviyoForm--9c51a";
export var light = "klaviyoForm-module--light--8c920";
export var richText = "klaviyoForm-module--richText--70de3";